<div class="dialog-content">
  @if (isFormLoading) {
    <div class="loading-tiers">
      <p>Loading tiers config</p>
      <mat-spinner class="spinner" [diameter]="28"></mat-spinner>
    </div>
  }
  @if (formGroup && !isFormLoading) {
    <form [formGroup]="formGroup">
      @if (tier?.id) {
        <div class="tier-title">Tier #{{ tier?.id }}</div>
      }
      @if (!tier?.id) {
        <div class="tier-title">Create new</div>
      }
      <div class="config-param" [class.shadowed]="!formGroup.controls.active.value">
        <mat-checkbox class="inline" formControlName="active"></mat-checkbox>
        <span class="inline keyword">Active</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.amountActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="amountActive"></mat-checkbox>
        <span class="inline keyword">Amount </span>
        <span class="inline">is min </span>
        <app-form-field-money
          class="inline"
          [data]="formGroup.controls.minAmount.value"
          [fieldConfig]="moneyConfig('minAmount')"
          [editMode]="formGroup.controls.amountActive.value"
          [formGroup]="this.formGroup">
        </app-form-field-money>
        <span class="inline">and max </span>
        <app-form-field-money
          class="inline"
          [data]="formGroup.controls.maxAmount.value"
          [fieldConfig]="moneyConfig('maxAmount')"
          [editMode]="formGroup.controls.amountActive.value"
          [formGroup]="this.formGroup">
        </app-form-field-money>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.amountPerDayActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="amountPerDayActive"></mat-checkbox>
        <span class="inline keyword">Total value of requests today </span>
        <span class="inline">is min</span>
        <app-form-field-money
          class="inline"
          [data]="formGroup.controls.minAmountPerDay.value"
          [fieldConfig]="moneyConfig('minAmountPerDay')"
          [editMode]="formGroup.controls.amountPerDayActive.value"
          [formGroup]="this.formGroup">
        </app-form-field-money>
        <span class="inline">and max </span>
        <app-form-field-money
          class="inline"
          [data]="formGroup.controls.maxAmountPerDay.value"
          [fieldConfig]="moneyConfig('maxAmountPerDay')"
          [editMode]="formGroup.controls.amountPerDayActive.value"
          [formGroup]="this.formGroup">
        </app-form-field-money>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.requestsPerDayActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="requestsPerDayActive"></mat-checkbox>
        <span class="inline keyword">Number of requests today </span>
        <span class="inline">is min </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.requestsPerDayActive.value"
          formControlName="minRequestsPerDay" />
        <span class="inline">and max </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.requestsPerDayActive.value"
          formControlName="maxRequestsPerDay" />
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.lifetimeAmountActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="lifetimeAmountActive"></mat-checkbox>
        <span class="inline keyword">Total value of requests in lifetime </span>
        <span class="inline">is min </span>
        <app-form-field-money
          class="inline"
          [data]="formGroup.controls.minLifetimeAmount.value"
          [fieldConfig]="moneyConfig('minLifetimeAmount')"
          [editMode]="formGroup.controls.lifetimeAmountActive.value"
          [formGroup]="this.formGroup">
        </app-form-field-money>
        <span class="inline">and max </span>
        <app-form-field-money
          class="inline"
          [data]="formGroup.controls.maxLifetimeAmount.value"
          [fieldConfig]="moneyConfig('maxLifetimeAmount')"
          [editMode]="formGroup.controls.lifetimeAmountActive.value"
          [formGroup]="this.formGroup">
        </app-form-field-money>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.lifetimeRequestsActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="lifetimeRequestsActive"></mat-checkbox>
        <span class="inline keyword">Number of requests in lifetime </span>
        <span class="inline">is min </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.lifetimeRequestsActive.value"
          formControlName="minLifetimeRequests" />
        <span class="inline">and max</span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.lifetimeRequestsActive.value"
          formControlName="maxLifetimeRequests" />
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.cardsNumberActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="cardsNumberActive"></mat-checkbox>
        <span class="inline keyword">Number of player's active cards </span>
        <span class="inline">is min </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.cardsNumberActive.value"
          formControlName="cardsNumberMin" />
        <span class="inline">and max </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.cardsNumberActive.value"
          formControlName="cardsNumberMax" />
        <span class="inline shadowed">(Only for CARD requests)</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.totalCardsNumberActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="totalCardsNumberActive"></mat-checkbox>
        <span class="inline keyword">Total number of player's cards </span>
        <span class="inline">is min </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.totalCardsNumberActive.value"
          formControlName="totalCardsNumberMin" />
        <span class="inline">and max </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.totalCardsNumberActive.value"
          formControlName="totalCardsNumberMax" />
        <span class="inline shadowed">(Only for CARD requests)</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.acceptedForCardActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="acceptedForCardActive"></mat-checkbox>
        <span class="inline keyword">Number of requests accepted for this card </span>
        <span class="inline">is min </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.acceptedForCardActive.value"
          formControlName="minAcceptedForCard" />
        <span class="inline">and max</span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.acceptedForCardActive.value"
          formControlName="maxAcceptedForCard" />
        <span class="inline shadowed">(Only for CARD requests)</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.cardAgeActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="cardAgeActive"></mat-checkbox>
        <span class="inline keyword">Days since card was added</span>
        <span class="inline">is more than </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.cardAgeActive.value"
          formControlName="minCardAgeDays" />
        <span class="inline shadowed">(Only for CARD requests)</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.cardDocumentVerified.value">
        <mat-checkbox class="inline" formControlName="cardDocumentVerified"></mat-checkbox>
        <span class="inline keyword">Card has been successfully verified with documents</span>
      </div>
      <div class="config-param">
        <span class="inline keyword">Last AVS result was one of </span>
        <br />
        @for (checkbox of avsResultValues; track checkbox; let i = $index) {
          <ng-container formArrayName="avsResultValues">
            <mat-checkbox type="checkbox" [formControlName]="i">{{ checkbox.name }}</mat-checkbox>
            <br />
          </ng-container>
        }
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.riskScoreActive.value">
        <mat-checkbox class="inline" matTooltip="Active" formControlName="riskScoreActive"></mat-checkbox>
        <span class="inline keyword">Highest risk score for payment type </span>
        <span class="inline">is less than </span>
        <input
          class="inline-input"
          type="number"
          [readOnly]="!formGroup.controls.riskScoreActive.value"
          formControlName="maxRiskScore" />
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.hvp.value">
        <mat-checkbox class="inline" formControlName="hvp"></mat-checkbox>
        <span class="inline keyword">HVP </span>
        <span class="inline">are allowed only</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.trustedCard.value">
        <mat-checkbox class="inline" formControlName="trustedCard"></mat-checkbox>
        <span class="inline keyword">Trusted cards</span>
        <span class="inline">are allowed only </span>
        <span class="inline shadowed">(Only for CARD requests)</span>
      </div>
      <div
        class="config-param"
        [class.shadowed]="
          !formGroup.controls.bonusAbuseA.value &&
          !formGroup.controls.bonusAbuseB.value &&
          !formGroup.controls.bonusAbuseC.value
        ">
        <span class="inline keyword">Bonus abusers </span>
        <span class="inline">can be processed when of the following type </span>
        <br />
        <mat-checkbox
          [class.shadowed]="!formGroup.controls.bonusAbuseA.value"
          class="inline spacing-right"
          formControlName="bonusAbuseA"
          >A
        </mat-checkbox>
        <mat-checkbox
          [class.shadowed]="!formGroup.controls.bonusAbuseB.value"
          class="inline spacing-right"
          formControlName="bonusAbuseB"
          >B
        </mat-checkbox>
        <mat-checkbox
          [class.shadowed]="!formGroup.controls.bonusAbuseC.value"
          class="inline spacing-right"
          formControlName="bonusAbuseC"
          >C
        </mat-checkbox>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.withdrawWatch.value">
        <mat-checkbox class="inline" formControlName="withdrawWatch"></mat-checkbox>
        <span class="inline keyword">Withdraw watch</span>
        <span class="inline"> players can be processed</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.allowOnDataMismatch.value">
        <mat-checkbox class="inline" formControlName="allowOnDataMismatch"></mat-checkbox>
        <span class="inline keyword">Data mismatch between player and payment type</span>
        <span class="inline">can be processed</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.withdrawLteDepositsForPaymentMethod.value">
        <mat-checkbox class="inline" formControlName="withdrawLteDepositsForPaymentMethod"></mat-checkbox>
        <span class="inline keyword">Total withdrawals for selected method <= total deposits for that method.</span>
      </div>
      <div class="config-param" [class.shadowed]="!formGroup.controls.minCashStakesToDepositsRatioActive.value">
        <mat-checkbox
          class="inline"
          matTooltip="Active"
          formControlName="minCashStakesToDepositsRatioActive"></mat-checkbox>
        <span class="inline keyword">Min cash stakes to deposits ratio </span>
        <span class="inline">is </span>
        <app-form-field-number
          class="inline"
          [data]="formGroup.controls.minCashStakesToDepositsRatio.value"
          [fieldConfig]="numberConfig('minCashStakesToDepositsRatio')"
          [editMode]="formGroup.controls.minCashStakesToDepositsRatioActive.value"
          [formGroup]="this.formGroup">
        </app-form-field-number>
      </div>
    </form>
  }
</div>

<div class="actions-content">
  <button (click)="close()" mat-stroked-button>Cancel</button>
  <button class="btn-confirm" mat-raised-button color="primary" [disabled]="!formGroup?.valid" (click)="save()">
    Save
  </button>
</div>
